export default function HomeIcon() {
  return (
    <>
      <svg
        width="18"
        height="19"
        viewBox="0 0 18 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.2495 17.4991V12.9991C11.2495 12.8001 11.1704 12.6094 11.0298 12.4687C10.8891 12.3281 10.6984 12.2491 10.4995 12.2491H7.49945C7.30054 12.2491 7.10977 12.3281 6.96912 12.4687C6.82847 12.6094 6.74945 12.8001 6.74945 12.9991V17.4991C6.74945 17.698 6.67045 17.8888 6.52981 18.0294C6.38918 18.1701 6.19844 18.2491 5.99954 18.2491L1.50009 18.2497C1.40159 18.2498 1.30406 18.2304 1.21305 18.1927C1.12205 18.155 1.03936 18.0998 0.969703 18.0301C0.900049 17.9605 0.844796 17.8778 0.807099 17.7868C0.769402 17.6958 0.75 17.5982 0.75 17.4997V8.83158C0.75 8.72709 0.771834 8.62375 0.814101 8.52819C0.856369 8.43264 0.918138 8.34696 0.995448 8.27667L8.49493 1.45778C8.63299 1.33226 8.81287 1.2627 8.99946 1.2627C9.18605 1.26269 9.36594 1.33223 9.504 1.45775L17.0045 8.27666C17.0818 8.34696 17.1436 8.43264 17.1859 8.5282C17.2282 8.62377 17.25 8.72711 17.25 8.83161V17.4997C17.25 17.5982 17.2306 17.6958 17.1929 17.7868C17.1552 17.8778 17.1 17.9605 17.0303 18.0301C16.9606 18.0998 16.878 18.155 16.7869 18.1927C16.6959 18.2304 16.5984 18.2498 16.4999 18.2497L11.9994 18.2492C11.8005 18.2491 11.6097 18.1701 11.4691 18.0295C11.3285 17.8888 11.2494 17.698 11.2495 17.4991V17.4991Z"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </>
  );
}
